import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, Content, IconWrapper, Title, Subtitle } from "./Card.style";
var Card = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, icon = _a.icon, size = _a.size, color = _a.color, onClick = _a.onClick;
    return (_jsxs(Container, { size: size, onClick: onClick, children: [icon && _jsx(IconWrapper, { children: icon }), _jsxs(Content, { children: [_jsx(Title, { children: title }), subtitle && _jsx(Subtitle, { color: color, children: subtitle })] })] }));
};
export default Card;
